import React from "react";
import { parseApiDate } from "../../utils/date";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Text,
    VStack,
    Box,
    Divider,
} from "@chakra-ui/react";

const TicketDetailsModal = ({ ticket, onClose }) => {
    const dateTimeFormat = new Intl.DateTimeFormat("hr-HR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "Europe/Zagreb",
    })
        .format(parseApiDate(ticket.createdAt))
        .replace(/\s+/g, "") // Remove spaces
        .replace(/(\d{2})\.(\d{2})\.(\d{4})\.(\d{2}:\d{2})/, "$1.$2.$3 $4");

    return (
        <Modal isOpen={true} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Detalji zadatka</ModalHeader>
                <ModalBody>
                    <VStack align="start" spacing={3}>
                        <Box>
                            <Text fontWeight="bold">Naziv:</Text>
                            <Text>{ticket.name}</Text>
                        </Box>
                        <Divider />
                        <Box>
                            <Text fontWeight="bold">Opis:</Text>
                            <Text>{ticket.description}</Text>
                        </Box>
                        <Divider />
                        <Box>
                            <Text fontWeight="bold">Odjeljak:</Text>
                            <Text>{ticket.sectionName || "N/A"}</Text>
                        </Box>
                        <Divider />
                        <Box>
                            <Text fontWeight="bold">Status:</Text>
                            <Text>
                                {ticket.status === 0 && "Prijavljen"}
                                {ticket.status === 10 && "U postupku"}
                                {ticket.status === 20 && "Otkazan"}
                                {ticket.status === 30 && "Završen"}
                                {ticket.status === 40 && "Arhiviran"}
                            </Text>
                        </Box>
                        <Divider />
                        <Box>
                            <Text fontWeight="bold">Kreirao:</Text>
                            <Text>{ticket.createdByFullName}</Text>
                        </Box>
                        <Divider />
                        <Box>
                            <Text fontWeight="bold">Kreiran:</Text>
                            <Text>{dateTimeFormat}</Text>
                        </Box>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="blue" onClick={onClose}>
                        Povratak
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default TicketDetailsModal;
